var a = { icon: { tag: "svg", attrs: { viewBox: "0 0 16 16", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M12 0a1 1 0 011 1v3h2a1 1 0 011 1v7a1 1 0 01-1 1h-2v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2H1a1 1 0 01-1-1V5a1 1 0 011-1h2V1a1 1 0 011-1h8zm-.7 9.7H4.7v4.6h6.6V9.7zm3-4H1.7v5.6H3V9a1 1 0 011-1h8a1 1 0 011 1v2.3h1.3V5.7zm-3-4H4.7V4h6.6V1.7z", "fill-rule": "nonzero" } }] }, name: "print", theme: "outlined" };
export {
  a as default
};
